module.exports = __webpack_public_path__ + "img/lrxx.6b75b36a.png";